import { render } from "./TMDBDetailModal.vue?vue&type=template&id=3cd55410&scoped=true"
import script from "./TMDBDetailModal.vue?vue&type=script&lang=js"
export * from "./TMDBDetailModal.vue?vue&type=script&lang=js"

import "./TMDBDetailModal.vue?vue&type=style&index=0&id=3cd55410&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd55410"]])

export default __exports__